import React from "react";

import { t } from "i18next";
import { useTranslation } from "react-i18next";

import Icon, { DropDownIcon } from "Atoms/Icons";

import { Price } from "../Atoms";
import {
  useCurrentCustomerTab,
  useCustomerTab,
  useCustomerTabQuery,
  useLoadedCustomerTab,
} from "../CustomerTab/queries";
import { OrderItem } from "../CustomerTab/schema";
import { useSession } from "../Session/SessionContext";

const OrderedOrderItem = ({ orderItem }: { orderItem: OrderItem }) => {
  const { t } = useTranslation();
  return (
    <div className="flex bg-venue-tertiary shadow-venue-brand-style rounded-venue-brand p-12 flex-wrap text-base font-medium items-center gap-8">
      {orderItem.itemHeroImageThumbnailUrl && (
        <div className="flex-none">
          <div className="  flex-none aspect-w-1 aspect-h-1 w-[80px] ">
            <img
              src={orderItem.itemHeroImageThumbnailUrl}
              className="rounded-venue-brand object-cover"
            />
          </div>
        </div>
      )}
      <div className="flex-1">
        {t("onlinePayments.orderItem", {
          count: orderItem.multiplier,
          itemName: orderItem.itemName,
        })}
        <ul className="text-xs font-normal list-disc">
          {orderItem.orderItemMods.map((mod) => mod.name).join(", ")}
        </ul>
      </div>
      <div>
        <div>
          <Price value={orderItem.totalSalesPriceTaxInclusive} />
        </div>
      </div>
    </div>
  );
};

// KEEP - used to show already ordered items
const isVoided = (orderItem: OrderItem) => orderItem.voided;
const isNotVoided = (orderItem: OrderItem) => !orderItem.voided;
export const OrderedOrderItems = () => {
  const { t } = useTranslation();
  const session = useSession();
  const { data: customerTab } = useCustomerTabQuery(session.customerTab?.uuid);
  const [showVoided, setShowVoided] = React.useState(false);
  if (!customerTab || customerTab?.orders.length === 0) {
    return null;
  }
  const voidedItems = customerTab.orders
    .flatMap((order) => order.orderItems)
    .filter(isVoided);
  return (
    <div className="space-y-32">
      <div className="space-y-12">
        <h3 className="text-2xl font-medium text-center ">
          {t("cart.pastOrderedItems")}
        </h3>
        <div className="space-y-8">
          {customerTab.orders
            .flatMap((order) => order.orderItems)
            .filter(isNotVoided)
            .map((orderItem) => (
              <OrderedOrderItem key={orderItem.uuid} orderItem={orderItem} />
            ))}
        </div>
      </div>
      {voidedItems.length >= 1 && (
        <div className="space-y-12">
          <h3
            onClick={() => {
              setShowVoided(!showVoided);
            }}
            className="text-lg cursor-pointer font-medium text-center "
          >
            {t("cart.voidedItems", { count: voidedItems.length })}
            <DropDownIcon
              isExpanded={!showVoided}
              rotateBy={undefined}
              color="venue-primary"
            />
          </h3>
          {showVoided && (
            <div className="space-y-8">
              {voidedItems.map((orderItem) => (
                <OrderedOrderItem orderItem={orderItem} />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
